import { Socket } from "./Socket";
export class String extends Socket {
    processReceived(data) {
        return data?.arrayBuffer
            ? new TextDecoder().decode(data.arrayBuffer())
            : typeof data != "string"
                ? new TextDecoder().decode(data)
                : data;
    }
    processSend(data) {
        return data;
    }
}
//# sourceMappingURL=String.js.map